import React, { useContext } from 'react';

import { ConditionalRendering } from '@components/common/conditional-rendering';
import { INPUT_TYPES } from '@components/common/form/constants/fieldTypes';
import { APPLICATION_TYPES, ApplicationType } from '@constants/enrollmentList/enrollmentList.constant';
import { usePermissions } from '@hooks/usePermissions';
import Dropdown from '@lib/inputs/Dropdown';
import { useSelector } from 'react-redux';
import { IEnrollmentPremiumDto } from '../../common/types';
import { EnrollmentContext } from '../../context/MemberMyEnrollmentProvider';

const ColumnApplicationType = ({
    premium,
    isMedicaidTransitionEnabled,
}: {
    premium: IEnrollmentPremiumDto;
    isMedicaidTransitionEnabled: boolean;
}) => {
    const permissions = useSelector((state: any) => state.memberEnrollment?.permissions);
    const { userPermissions } = permissions || {};
    const { viewApplicationType } = usePermissions();
    const { enableContinueButton, enrollmentPremiumFormContext, selectedEnrollment } = useContext(EnrollmentContext);
    const { watch, setValue, trigger } = enrollmentPremiumFormContext;
    const values = watch();

    const updateApplicationType = (premium, value) => {
        let updatedEnrollment = premium;
        if (value === ApplicationType.Financial) {
            updatedEnrollment = {
                ...updatedEnrollment,
                isAptcEligible: true,
                aptcAmount: null,
                maxAptc: null,
                netPremiumAmount: parseFloat(premium.grossPremiumAmount) || 0,
                stateSubsidyAmount: premium.isStateSubsidyEligible ? 0 : null,
                stateSubsidy2Amount: premium.isStateSubsidy2Eligible ? 0 : null,
                maxStateSubsidy: premium.isStateSubsidyEligible ? 0 : null,
                medicaidTransitionAmount: isMedicaidTransitionEnabled ? 0 : null,
                isFinancial: true,
            };
        } else {
            updatedEnrollment = {
                ...updatedEnrollment,
                aptcAmount: null,
                maxAptc: null,
                netPremiumAmount: parseFloat(premium.grossPremiumAmount) || 0,
                stateSubsidyAmount: null,
                stateSubsidy2Amount: null,
                maxStateSubsidy: null,
                medicaidTransitionAmount: null,
                isFinancial: false,
            };
        }
        setValue(`enrollmentPremiumDtoList.${premium.month - 1}`, updatedEnrollment, {
            shouldDirty: true,
            shouldValidate: true,
        });

        enableContinueButton();
    };

    return (
        <ConditionalRendering isTrue={viewApplicationType(premium, values)}>
            <Dropdown
                label={{
                    text: '',
                    labelClass: [''],
                }}
                inputData={{
                    id: 'applicationType',
                    inputClasses: [''],
                    options: APPLICATION_TYPES,
                    type: INPUT_TYPES.DROPDOWN,
                    value: premium.isFinancial ? 'Financial' : 'Non-Financial',
                    isInputRequired: false,
                    disabled: values.isItf,
                }}
                inputActions={{
                    handleFieldChange: value => updateApplicationType(premium, value),
                }}
            />
        </ConditionalRendering>
    );
};

export default ColumnApplicationType;
